import { toast } from "react-toastify";
import {
  CLIENT_ADD_SUCCESS,
  CLIENT_ADD_REQUEST,
  CLIENT_ADD_FAIL,
  //
  CLIENT_LIST_SUCCESS,
  CLIENT_LIST_REQUEST,
  CLIENT_LIST_FAIL,
  //
  CLIENT_DETAIL_SUCCESS,
  CLIENT_DETAIL_REQUEST,
  CLIENT_DETAIL_FAIL,
  //
  CLIENT_DELETE_SUCCESS,
  CLIENT_DELETE_REQUEST,
  CLIENT_DELETE_FAIL,
  //
  CLIENT_UPDATE_SUCCESS,
  CLIENT_UPDATE_REQUEST,
  CLIENT_UPDATE_FAIL,
  //

  //
} from "../constants/clientContants";

export const deleteClientReducer = (state = {}, action) => {
  switch (action.type) {
    case CLIENT_DELETE_REQUEST:
      return { loadingClientDelete: true };
    case CLIENT_DELETE_SUCCESS:
      toast.success("This Client has been successfully deleted.");
      return {
        loadingClientDelete: false,
        successClientDelete: true,
      };
    case CLIENT_DELETE_FAIL:
      return {
        loadingClientDelete: false,
        errorClientDelete: action.payload,
        successClientDelete: false,
      };
    default:
      return state;
  }
};

export const updateCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case CLIENT_UPDATE_REQUEST:
      return { loadingCategoryUpdate: true };
    case CLIENT_UPDATE_SUCCESS:
      toast.success("This Category has been successfully updated");
      return {
        loadingCategoryUpdate: false,
        successCategoryUpdate: true,
      };
    case CLIENT_UPDATE_FAIL:
      return {
        loadingCategoryUpdate: false,
        errorCategoryUpdate: action.payload,
        successCategoryUpdate: false,
      };
    default:
      return state;
  }
};

export const detailCategoryReducer = (state = { categoryInfo: {} }, action) => {
  switch (action.type) {
    case CLIENT_DETAIL_REQUEST:
      return { loadingCategoryInfo: true };
    case CLIENT_DETAIL_SUCCESS:
      return {
        loadingCategoryInfo: false,
        successCategoryInfo: true,
        categoryInfo: action.payload.category,
      };
    case CLIENT_DETAIL_FAIL:
      return {
        loadingCategoryInfo: false,
        successCategoryInfo: false,
        errorCategoryInfo: action.payload,
      };
    default:
      return state;
  }
};

export const createNewCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case CLIENT_ADD_REQUEST:
      return { loadingCategoryAdd: true };
    case CLIENT_ADD_SUCCESS:
      toast.success("This category has been added successfully");
      return {
        loadingCategoryAdd: false,
        successCategoryAdd: true,
      };
    case CLIENT_ADD_FAIL:
      toast.error(action.payload);
      return {
        loadingCategoryAdd: false,
        successCategoryAdd: false,
        errorCategoryAdd: action.payload,
      };
    default:
      return state;
  }
};

export const getListClientsReducer = (state = { clients: [] }, action) => {
  switch (action.type) {
    case CLIENT_LIST_REQUEST:
      return { loadingListClients: true, clients: [] };
    case CLIENT_LIST_SUCCESS:
      return {
        loadingListClients: false,
        clients: action.payload.users,
      };
    case CLIENT_LIST_FAIL:
      return {
        loadingListClients: false,
        errorListClients: action.payload,
      };
    default:
      return state;
  }
};
